// extracted by mini-css-extract-plugin
export default {"langSwitch":"langSwitch--RUUp8","icon":"icon--oM2Ge","langs":"langs--E9KhJ","labels":"labels--QgGOB","lang":"lang--A3JJK"};